/* eslint-disable max-len */
import React from "react"
import PropTypes from "prop-types"
import id from "@irati/utils/id"
import BaseSvgIcon from "./Base"

const Report = ({id: _id = "report-icon", title = "Reports", fill = "#3d3d35", ...rest}) => {
  const props = {id: _id, title, fill, ...rest}
  const titleId = id("title", props)

  return (
    <BaseSvgIcon {...rest}>
      <title id={titleId}>{title}</title>
      <g id="Layer_2">
        <path
          fill={fill}
          d="M18.37,5.54a.61.61,0,0,0,0-.13.75.75,0,0,0-.09-.15s0,0,0-.06h0L13.81.55h0a.48.48,0,0,0-.16-.12l0,0-.12,0-.13,0H7.5A.65.65,0,0,0,6.85,1V15.39A.65.65,0,0,0,7.5,16H17.74a.65.65,0,0,0,.65-.65V5.64S18.37,5.58,18.37,5.54ZM14,2.63,16.23,5H14Zm3.1,12.11H8.15V1.65h4.54v4a.65.65,0,0,0,.65.65h3.75Z"
        />
        <path fill={fill} d="M16.22,16.77l-10.29.07V2.43a.65.65,0,0,0-1.3,0V16.84a1.23,1.23,0,0,0,1.23,1.23H16.22a.65.65,0,1,0,0-1.3Z" />
      </g>
    </BaseSvgIcon>
  )
}

Report.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  fill: PropTypes.string
}

export default Report
